import styled from 'styled-components';
import {
    colorBackground,
    headerHeight,
    mediaMd,
    mediaSm,
    transitionBase,
} from '../../../../theme/theme-helper-selectors';

export const MobileWrap = styled.div`
    transition: ${transitionBase};
    position: relative;
    display: flex;

    @media (${mediaMd}) {
        max-height: calc(100vh - ${headerHeight});
    }

    @media (${mediaSm}) {
        overflow: auto;
        flex-direction: column;
        background: ${colorBackground};
    }
`;
